export default __webpack_public_path__ + "static/media/v1_footer_bg.e9117eca.png";